const state = {
  map: null,
  hasmap: true,
  ggMap: null,
  hoverName: {},
  seleNav: 0,
  mapLayer: "",
  lcRightBar: "",
  isPoint: {},
  isBase: {
    name: "全部",
    xmax: 12571334.441441875,
    xmin: 12408294.260109812,
    ymax: 2522479.5239989622,
    ymin: 2442908.5775542012,
    level: 10
  },
  layerCode: "",
  layerIndexId: null,
  mapComponent: null,
  layerComponent: null,
  bottomList: [],
  baiduShow: false,
  granaryIndex: 0,
  maptype: null // ly or gy, //产业亮点当前地图的显示状态，默认不选中,
};

const mutations = {
  SET_MAP: (state, map) => {
    state.map = map;
  },
  SET_GG_MAP: (state, map) => {
    state.ggMap = map;
  },
  SET_LAYER_CODE: (state, component) => {
    state.layerCode = component;
  },
  SET_HOVER_NAME: (state, param) => {
    state.hoverName = param;
  },
  SET_SELE_NAV: (state, seleNav) => {
    state.seleNav = seleNav;
  },
  SET_MAP_LAYER: (state, v) => {
    state.mapLayer = v;
  },
  SET_IS_POINT: (state, v) => {
    state.isPoint = v;
  },
  SET_LC_RIGHT_BAR: (state, v) => {
    state.lcRightBar = v;
  },
  SET_IS_BASE: (state, v) => {
    state.isBase = v;
  },
  SET_HASMAP: (state, v) => {
    state.hasmap = v;
  },
  SET_MAP_COMPONENT: (state, component) => {
    state.mapComponent = component;
  },
  SET_LAYER_COMPONENT: (state, component) => {
    state.layerComponent = component;
  },
  SET_LAYER_INDEX_ID: (state, id) => {
    state.layerIndexId = id;
  },
  SET_BOTTOM_LIST: (state, bottomList) => {
    state.bottomList = bottomList;
  },
  SET_BAIDU_SHOW: (state, baiduShow) => {
    state.baiduShow = baiduShow;
  },
  SET_GRANARY_INDEX: (state, v) => {
    state.granaryIndex = v;
  },
  SET_LD_MAPTYPE: (state, v) => {
    state.maptype = v;
  }
};

const actions = {
  setMap({ commit }, map) {
    commit("SET_MAP", map);
  },
  setGgMap({ commit }, map) {
    commit("SET_GG_MAP", map);
  },
  setHoverName({ commit }, param) {
    commit("SET_HOVER_NAME", param);
  },
  setLayerCode({ commit }, component) {
    commit("SET_LAYER_CODE", component);
  },
  setSeleNav({ commit }, seleNav) {
    commit("SET_SELE_NAV", seleNav);
  },
  setMapLayer({ commit }, v) {
    commit("SET_MAP_LAYER", v);
  },
  setLayerComponent({ commit }, v) {
    commit("SET_LAYER_COMPONENT", v);
  },
  setIsPoint({ commit }, v) {
    commit("SET_IS_POINT", v);
  },
  setLcRightBar({ commit }, v) {
    commit("SET_LC_RIGHT_BAR", v);
  },
  setIsBase({ commit }, v) {
    commit("SET_IS_BASE", v);
  },
  setHasmap({ commit }, v) {
    commit("SET_HASMAP", v);
  },
  setMapComponent({ commit }, component) {
    commit("SET_MAP_COMPONENT", component);
  },
  setLayerIndexId({ commit }, id) {
    commit("SET_LAYER_INDEX_ID", id);
  },
  setBottomList({ commit }, bottomList) {
    commit("SET_BOTTOM_LIST", bottomList);
  },
  setBaiduShow({ commit }, value) {
    commit("SET_BAIDU_SHOW", value);
  },
  setGranaryIndex({ commit }, v) {
    commit("SET_GRANARY_INDEX", v);
  },
  setLdMaptype({ commit }, v) {
    commit("SET_LD_MAPTYPE", v);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
